import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';

const Brands = () => {
  const [hoveredBrand, setHoveredBrand] = useState(null);

  // Add your brands here with their logo URLs
  const brands = [
    {
      id: 1,
      name: 'VESHH-EON',
      logo: 'https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/icon_confirm_mail_i78ri8',
      description: 'Premium Streetwear',
      url: 'https://www.dripptour.in/collections/VESHH-EON'
    },
    {
      id: 2,
      name: 'Brand Name',
      logo: 'https://images.unsplash.com/photo-1611312449408-fcece27cdbb7?w=400&h=400&fit=crop',
      description: 'Luxury Fashion',
      url: 'https://www.dripptour.in/collections/brand-name'
    },
    {
      id: 3,
      name: 'Another Brand',
      logo: 'https://images.unsplash.com/photo-1617127365659-c47fa864d8bc?w=400&h=400&fit=crop',
      description: 'Urban Style',
      url: 'https://www.dripptour.in/collections/another-brand'
    },
    {
      id: 4,
      name: 'Style Co.',
      logo: 'https://images.unsplash.com/photo-1564584217132-2271feaeb3c5?w=400&h=400&fit=crop',
      description: 'Contemporary Wear',
      url: 'https://www.dripptour.in/collections/style-co'
    },
    {
      id: 5,
      name: 'Elite Fashion',
      logo: 'https://images.unsplash.com/photo-1523381294911-8d3cead13475?w=400&h=400&fit=crop',
      description: 'Designer Collections',
      url: 'https://www.dripptour.in/collections/elite-fashion'
    },
    {
      id: 6,
      name: 'Trend Setters',
      logo: 'https://images.unsplash.com/photo-1591561954555-607968c989ab?w=400&h=400&fit=crop',
      description: 'Modern Aesthetics',
      url: 'https://www.dripptour.in/collections/trend-setters'
    },
    {
      id: 7,
      name: 'Luxe Label',
      logo: 'https://images.unsplash.com/photo-1558769132-cb1aea3c770b?w=400&h=400&fit=crop',
      description: 'Haute Couture',
      url: 'https://www.dripptour.in/collections/luxe-label'
    },
    {
      id: 8,
      name: 'Icon Wear',
      logo: 'https://images.unsplash.com/photo-1556906781-9a412961c28c?w=400&h=400&fit=crop',
      description: 'Street Luxury',
      url: 'https://www.dripptour.in/collections/icon-wear'
    }
  ];

  const handleBrandClick = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div className="min-h-screen bg-white">


      <div className="relative z-10 px-6 py-20 mx-auto max-w-7xl">
        {/* Header Section */}
        <div className="text-center mb-20 space-y-6">
          <div className="inline-flex items-center gap-2 px-5 py-2 border border-black/10 rounded-full mb-4">
            <Sparkles className="w-4 h-4 text-black" />
            <span className="text-xs text-black font-semibold tracking-[0.2em] uppercase">Curated Collection</span>
          </div>
          
          <h1 className="text-7xl md:text-8xl font-semibold text-black tracking-tight leading-none">
            Shop by Brands
          </h1>
          
          <div className="w-24 h-[1px] bg-black/20 mx-auto mt-8"></div>
          
          <p className="text-lg text-gray-600 max-w-xl mx-auto font-light leading-relaxed">
            Discover exceptional craftsmanship from the world's most distinguished fashion houses
          </p>
        </div>

        {/* Brands Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12 md:gap-16 lg:gap-20 mt-24">
          {brands.map((brand) => (
            <div
              key={brand.id}
              className="group cursor-pointer"
              onMouseEnter={() => setHoveredBrand(brand.id)}
              onMouseLeave={() => setHoveredBrand(null)}
              onClick={() => handleBrandClick(brand.url)}
            >
              <div className="relative">
                {/* Brand Circle */}
                <div className="relative mx-auto" style={{ width: '100%', paddingBottom: '100%' }}>
                  <div className={`absolute inset-0 rounded-full overflow-hidden border-2 transition-all duration-700 ease-out ${
                    hoveredBrand === brand.id 
                      ? 'border-black shadow-2xl scale-105' 
                      : 'border-gray-200 shadow-lg'
                  }`}>
                    <img
                      src={brand.logo}
                      alt={brand.name}
                      className={`w-full h-full object-cover transition-all duration-1000 ease-out ${
                        hoveredBrand === brand.id ? 'scale-110 grayscale-0' : 'scale-100 grayscale'
                      }`}
                    />
                    
                    {/* Subtle Overlay */}
                    <div className={`absolute inset-0 bg-black transition-opacity duration-500 ${
                      hoveredBrand === brand.id ? 'opacity-0' : 'opacity-10'
                    }`}></div>
                  </div>
                </div>
              </div>

              {/* Brand Info */}
              <div className="mt-8 text-center space-y-2">
                <h3 className={`text-base font-medium tracking-wide transition-all duration-500 ${
                  hoveredBrand === brand.id 
                    ? 'text-black translate-y-0' 
                    : 'text-gray-900 translate-y-1'
                }`}>
                  {brand.name}
                </h3>
                <div className={`h-[1px] w-8 mx-auto transition-all duration-500 ${
                  hoveredBrand === brand.id ? 'w-16 bg-black' : 'w-8 bg-gray-300'
                }`}></div>
                <p className={`text-xs text-gray-500 tracking-wider uppercase transition-opacity duration-500 ${
                  hoveredBrand === brand.id ? 'opacity-100' : 'opacity-60'
                }`}>
                  {brand.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="mt-32 text-center border-t border-gray-200 pt-16">
          <div className="max-w-2xl mx-auto space-y-8">
            <h3 className="text-3xl font-light text-black tracking-tight">
              Elevate Your Collection
            </h3>
            <p className="text-gray-600 font-light leading-relaxed">
              Are you a brand looking to showcase your exceptional products? 
              Join our curated marketplace and connect with discerning customers.
            </p>
            <a 
  href="https://www.dripptour.in/contact" 
  target="_blank" 
  rel="noopener noreferrer"
  className="group relative inline-block px-10 py-4 bg-black text-white font-medium text-sm tracking-wider uppercase overflow-hidden transition-all duration-300 hover:bg-gray-900"
>
  <span className="relative z-10">Become a Partner</span>
  <div className="absolute inset-0 bg-gradient-to-r from-gray-800 to-black transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Brands;
